import { observable, action, runInAction, computed } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { companies } from '@services/api'

export class companiesStore extends StoreExt {
    @observable list = []
    @observable filteredList = []
    @observable filterText = ''
    @observable hmoList = []

    @action
    getCompanies = async () => {
        const { data: list } = await companies.getList()
        runInAction(() => {
            this.list = list
            this.filterList(this.filterText)
        })
    }
    @action
    getHmoList = async () => {
        const { data: list } = await companies.getHmoList()
        runInAction(() => {
            this.list = list
        })
    }
    @action
    getHmoWithPlansList = async () => {
        const  data = (await companies.getHmoList()).data
        runInAction(() => {
            this.hmoList = data

        })
    }
@computed get hmoNames() {

    return this.hmoList.map(hmo => ({ id: hmo.id, name: hmo.name }))
}
@computed get hmoPlans(){
    const plans =  this.hmoList.map(hmo=>hmo.plans)
    const plansObj  = {...plans}


        return plansObj
}
@computed
get hmoPlansList(){
        return this.hmoList
}
    @action
    getHMO = async () => {
        const { data: list } = await companies.getHmoList()
        runInAction(() => {
            this.list = list
            this.filterList(this.filterText)
        })
    }


    @action
    filterList = filterText => {
        this.filterText = filterText
        this.filteredList = this.list.filter(item => item.name.includes(filterText) || item.id === filterText)
    }

    @action
    resetCompanies = () => {
        this.list = []
        this.filteredList = []
        this.filterText = ''
    }
}

export default remotedev(new companiesStore())
